import { Component, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
declare var $: any;

@Component({
    selector: 'map-table-cells',
    templateUrl: './map-table-cells.component.html',
    styleUrls: ['./map-table-cells.component.css']
})

export class MapTableCellsComponent {
    private container: any;
    private contactAndContactListKeys: string[] = [];
    private tableHeaders: string[] = [];
    private selectedTableHeaders: string[] = [];

    @ViewChild('importFileAssignForm', { static: false }) importFileAssignForm: NgForm;

    @Output()
    private saved: EventEmitter<MappedTableCells> = new EventEmitter<MappedTableCells>();

    constructor() { }

    ngOnInit() {
        this.container = $('#importFilesAssign');
    }

    public show(contactAndContactListKeys: string[], tableHeaders: string[]) {
        this.selectedTableHeaders = [];
        this.contactAndContactListKeys = [];
        this.tableHeaders = [];

        this.importFileAssignForm.reset();
        this.contactAndContactListKeys = contactAndContactListKeys;
        this.tableHeaders = tableHeaders;
    }

    public save(): boolean {
        if (this.importFileAssignForm.valid) {
            let mappedTable = new MappedTableCells(this.contactAndContactListKeys, this.selectedTableHeaders);
            this.saved.emit(mappedTable);
            return true;
        } else {
            Object.keys(this.importFileAssignForm.controls)
                .forEach(fieldName => {
                    this.importFileAssignForm.controls[fieldName].markAsTouched();
                });
            return false;
        }
    }
}

export class MappedTableCells {
    contactAndContactListKeys: string[];
    selectedTableHeaders: string[];

    constructor(contactAndContactListKeys: string[], selectedTableHeaders: string[]) {
        this.contactAndContactListKeys = contactAndContactListKeys;
        this.selectedTableHeaders = selectedTableHeaders;
    }
}
